export function swapKeysAndValues(obj: Record<string, string>): Record<string, string> {
    const newObj: Record<string, string> = {};
    for (const key of Object.keys(obj)) {
        newObj[obj[key]] = key;
    }
    return newObj;
}
